import { useSyncExternalStore } from "react";
import { Icon } from "./Icon";

type Resolve = (path: string) => { name: string; viewBox: string };

// The icon set loads after the first paint; until then, a plain file icon.
let resolve: Resolve | undefined;
let started = false;
const listeners = new Set<() => void>();
function load() {
  if (started) return;
  started = true;
  void import("./file-icons").then((m) => {
    resolve = m.fileIcon;
    for (const listener of listeners) listener();
  });
}
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  load();
  return () => listeners.delete(listener);
};

/** A file's type icon (the file tree's icon set). */
export function FileIcon({ path, size = 14 }: { path: string; size?: number }) {
  const resolveIcon = useSyncExternalStore(subscribe, () => resolve);
  if (!resolveIcon) return <Icon name="file" size={size} />;
  const icon = resolveIcon(path);
  return (
    <svg
      className="file-icon"
      width={size}
      height={size}
      viewBox={icon.viewBox}
      aria-hidden="true"
      focusable="false"
    >
      <use href={`#${icon.name}`} />
    </svg>
  );
}
